import { useMemo } from 'react';

import { usePendingReceivedGroupInvites } from '~/domains/group/hooks/useReceivedGroupInvites';

export const useHomeGroupInvites = () => {
  const { pendingInvites, isLoading } = usePendingReceivedGroupInvites();

  const groupInvitesProps = useMemo(() => {
    if (isLoading || pendingInvites.length === 0) {
      return undefined;
    }

    return {
      content: { type: 'groupInvites' as const, groupInvites: pendingInvites },
      totalCount: pendingInvites.length,
    };
  }, [isLoading, pendingInvites]);

  return { groupInvitesProps, isGroupInvitesLoading: isLoading };
};
